'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./ButtonTooltip.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonTooltip = function (_PureComponent) {
  (0, _inherits3.default)(ButtonTooltip, _PureComponent);

  function ButtonTooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonTooltip.__proto__ || (0, _getPrototypeOf2.default)(ButtonTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      display: false
    }, _this.handleBlur = function () {
      _this.setState({ display: false });
    }, _this.handleFocus = function () {
      _this.setState({ display: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          Component = _props.Component,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['title', 'children', 'Component', 'className']);
      var display = this.state.display;


      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({
          className: className + ' ButtonTooltip',
          onBlur: this.handleBlur,
          onFocus: this.handleFocus
        }, props),
        children,
        display && title && _react2.default.createElement(
          'span',
          { className: 'Tooltip arrow-up' },
          title
        )
      );
    }
  }]);
  return ButtonTooltip;
}(_react.PureComponent);

ButtonTooltip.defaultProps = {
  Component: 'button'
};
exports.default = ButtonTooltip;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/ButtonTooltip/ButtonTooltip.js
// module id = 95
// module chunks = 0